import { useContext } from 'react';
import { ThemeContext } from '@/contexts/theme-context';
import type { IThemeContext } from '@/@types/theme';

export function useTheme(): IThemeContext {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
